<template lang="html">
	<section class="ctn-patrimonial-landscape">
		<h1>Paysage Patrimonial de {{ client.firstname }} {{ client.lastname }}</h1>
		<div class="subtitle">
			Complétez votre paysage patrimonial étape par étape ou librement en naviguant par thématique. Cliquez sur "Sauvegarder" pour enregistrer votre saisie au fur et à mesure. Vous pourrez le reprendre à tout moment en vous reconnectant. La validation de votre paysage patrimonial sera effective qu'une fois l'étape de signature réalisée.
		</div>
		<patrimonial-landscape :user="client"/>
  </section>
</template>

<script>
import PatrimonialLandscape from '@/common/components/MyPatrimonialLandscape/PatrimonialLandscape'

export default {
	name: 'PatrimonialLandscapeUpdate',
	data () {
		return {
			client: this.$store.getters.getClient(this.$route.params.clientId)
		}
	},
	components: {
		PatrimonialLandscape
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// PatrimonialLandscapeUpdate.vue?7e75e030